"use strict";

var _defineProperty2 = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/defineProperty.js").default;
var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _assertThisInitialized = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/assertThisInitialized.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShortDualNativepropertyValidator = void 0;
var _ShortMergeRequest = require("../ShortMergeRequest");
var _ShortCSSPropertyValidator = require("./ShortCSSPropertyValidator");
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var ShortDualNativepropertyValidator = /*#__PURE__*/function (_ShortCSSPropertyVali) {
  _inherits(ShortDualNativepropertyValidator, _ShortCSSPropertyVali);
  var _super = _createSuper(ShortDualNativepropertyValidator);
  function ShortDualNativepropertyValidator(params,
  /**
   * First direction, second direction.
   */
  directions) {
    var _this;
    _classCallCheck(this, ShortDualNativepropertyValidator);
    _this = _super.call(this, params);
    _defineProperty(_assertThisInitialized(_this), "directions", void 0);
    _this.directions = directions;
    return _this;
  } // These properties are only available for native styles.
  _createClass(ShortDualNativepropertyValidator, [{
    key: "normalizeInlineCSSValue",
    value: function normalizeInlineCSSValue() {
      return null;
    }
  }, {
    key: "normalizeNativeValue",
    value: function normalizeNativeValue(value) {
      var _ShortMergeRequest$Sh;
      return new _ShortMergeRequest.ShortMergeRequest((_ShortMergeRequest$Sh = {}, _defineProperty2(_ShortMergeRequest$Sh, this.directions[0], value), _defineProperty2(_ShortMergeRequest$Sh, this.directions[1], value), _ShortMergeRequest$Sh));
    }
  }]);
  return ShortDualNativepropertyValidator;
}(_ShortCSSPropertyValidator.ShortCSSPropertyValidator);
exports.ShortDualNativepropertyValidator = ShortDualNativepropertyValidator;